import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

function UpdateDialog({ open, currentVersion, latestVersion, onUpdateNow, onUpdateLater }) {
  return (
    <Dialog open={open} onClose={onUpdateLater} aria-labelledby="update-dialog-title">
      <DialogTitle id="update-dialog-title">Nueva versión disponible</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Hay una nueva versión de MiGarita.Online lista para instalar.
        </Typography>
        {currentVersion && (
          <Typography variant="body2" color="text.secondary">
            Versión actual: {currentVersion}
          </Typography>
        )}
        {latestVersion && (
          <Typography variant="body2" color="text.secondary">
            Nueva versión: {latestVersion}
          </Typography>
        )}
        <Typography variant="body2" sx={{ marginTop: 2 }}>
          Actualizar toma menos de un segundo.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onUpdateLater}>Más tarde</Button>
        <Button onClick={onUpdateNow} variant="contained" color="primary">
          Actualizar ahora
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UpdateDialog;
